// extracted by mini-css-extract-plugin
export var flex = "services-module--flex--1FfIE";
export var button = "services-module--button--187Jw";